// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"heroAsset_videoWrapper__SWknD","video":"heroAsset_video__iC9PD","image":"heroAsset_image__04DDF"};